export { LectureSingleFragment } from './fragments';
export { GetLectureQuery } from './queries';

export { UpdateLectureMutation, RemoveLectureMutation } from './mutations';
